// extracted by mini-css-extract-plugin
module.exports = {"categoryItem":"category-item_categoryItem__gMwdP"};